import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Input,
  InputNumber,
  Button,
  Table,
  Select,
  Typography,
  Tabs,
  message,
} from "antd";

import axios from "axios";
import UniversalModuleModal from "./UniversalModuleModal";
import { MODULE_MODAL_CONFIGS } from "./moduleModalConfigs";


const { Title } = Typography;
const { Option } = Select;


function DataAnalysis({
  fileId,
  fileName,
  setSelectedFile,
  initialConfig,
}) {


  const token = localStorage.getItem("access_token");


  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState("1");

  const [dataType, setDataType] = useState("raw");

  const [rawData, setRawData] = useState("");


  const [rows, setRows] = useState(
    initialConfig?.rows || 5
  );



  const [groupedRows, setGroupedRows] = useState(
    Array.from(
      { length: rows },
      () => ({
        value: "",
        frequency: ""
      })
    )
  );



  const [probabilityRows, setProbabilityRows] = useState(
    Array.from(
      { length: rows },
      () => ({
        value: "",
        probability: ""
      })
    )
  );



  const [result, setResult] = useState(null);





  useEffect(() => {

    setGroupedRows(
      Array.from(
        { length: rows },
        () => ({
          value: "",
          frequency: ""
        })
      )
    );


    setProbabilityRows(
      Array.from(
        { length: rows },
        () => ({
          value: "",
          probability: ""
        })
      )
    );


  }, [rows]);





  useEffect(() => {

    if (fileId) {
      retrieveFile();
    }

  }, [fileId]);





  const retrieveFile = async () => {


    try {


      const response = await axios.get(
        `/api/retrieve_data_analysis/${fileId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );



      const file = response.data;


      setResult(file.output_data || null);
      setActiveTab("2");



      const input = file.input_data;



      setDataType(input.data_type);



      if (input.data_type === "raw") {

        setRawData(
          input.data.join(",")
        );

      }



      if (input.data_type === "grouped") {


        setRows(input.values.length);


        setGroupedRows(

          input.values.map((v, i) => ({

            value: v,

            frequency: input.frequencies[i]

          }))

        );


      }




      if (input.data_type === "probability") {


        setRows(input.values.length);


        setProbabilityRows(

          input.values.map((v, i) => ({

            value: v,

            probability: input.probabilities[i]

          }))

        );


      }



    } catch (err) {

      console.log(
        "RETRIEVE ERROR",
        err
      );

    }


  };






  const buildInputData = () => {


    if (dataType === "raw") {


      return {

        data_type: "raw",

        data:
          rawData
            .split(",")
            .map(x => Number(x.trim()))
            .filter(x => !isNaN(x))

      };


    }





    if (dataType === "grouped") {


      return {

        data_type: "grouped",

        values:
          groupedRows.map(
            r => Number(r.value)
          ),


        frequencies:
          groupedRows.map(
            r => Number(r.frequency)
          )


      };


    }





    return {

      data_type: "probability",

      values:
        probabilityRows.map(
          r => Number(r.value)
        ),


      probabilities:
        probabilityRows.map(
          r => Number(r.probability)
        )


    };


  };






  const handleCalculate = async () => {


    setLoading(true);



    try {


      const payload = {

        name: fileName || "Data Analysis",

        input_data: buildInputData()

      };





      let response;




      if (fileId) {


        response = await axios.put(

          `/api/update_data_analysis/${fileId}/`,

          payload,

          {

            headers: {
              Authorization: `Bearer ${token}`
            }

          }

        );


      }

      else {


        response = await axios.post(

          "/api/save_data_analysis/",

          payload,

          {

            headers: {
              Authorization: `Bearer ${token}`
            }

          }

        );


      }





      console.log(
        "BACKEND RESPONSE",
        response.data
      );





      let output;



      if (response.data.output_data) {

        output = response.data.output_data;

      }

      else if (response.data.result) {

        output = response.data.result;

      }

      else {

        output = response.data;

      }





      console.log(
        "FINAL OUTPUT",
        output
      );





      setResult(output);



      // IMPORTANT
      setActiveTab("2");



      message.success(
        "Calculation Successful"
      );



    }

    catch (err) {


      console.log(
        "CALCULATION ERROR",
        err.response?.data || err
      );


      message.error(
        "Calculation Failed"
      );


    }



    setLoading(false);


  };






  const updateGroupedRow = (index, field, value) => {


    const temp = [...groupedRows];

    temp[index][field] = value;

    setGroupedRows(temp);


  };





  const updateProbabilityRow = (index, field, value) => {


    const temp = [...probabilityRows];

    temp[index][field] = value;

    setProbabilityRows(temp);


  };

  return (

    <Card>

      <Title level={3}>Data Analysis</Title>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: "1",
            label: "Input",

            children: (

              <>

                <Row gutter={16} style={{ marginBottom: 20 }}>

                  <Col span={8}>
                    <Select
                      value={dataType}
                      style={{ width: "100%" }}
                      onChange={setDataType}
                    >
                      <Option value="raw">Raw Data</Option>
                      <Option value="grouped">Grouped Data</Option>
                      <Option value="probability">
                        Probability Distribution
                      </Option>
                    </Select>
                  </Col>

                  {dataType !== "raw" && (

                    <Col span={6}>
                      <InputNumber
                        min={1}
                        value={rows}
                        style={{ width: "100%" }}
                        onChange={setRows}
                      />
                    </Col>

                  )}

                </Row>

                {dataType === "raw" && (

                  <Card title="Raw Data">

                    <Input.TextArea
                      rows={6}
                      placeholder="Example: 5,6,7,8,9,10"
                      value={rawData}
                      onChange={(e) =>
                        setRawData(e.target.value)
                      }
                    />

                  </Card>

                )}

                {dataType === "grouped" && (

                  <Card title="Grouped Data">

                    <Table
                      bordered
                      pagination={false}
                      rowKey={(r, i) => i}
                      dataSource={groupedRows}
                      columns={[
                        {
                          title: "Value",

                          render: (_, record, index) => (

                            <InputNumber
                              style={{ width: "100%" }}
                              value={record.value}
                              onChange={(v) =>
                                updateGroupedRow(
                                  index,
                                  "value",
                                  v
                                )
                              }
                            />

                          ),
                        },

                        {
                          title: "Frequency",

                          render: (_, record, index) => (

                            <InputNumber
                              style={{ width: "100%" }}
                              value={record.frequency}
                              onChange={(v) =>
                                updateGroupedRow(
                                  index,
                                  "frequency",
                                  v
                                )
                              }
                            />

                          ),
                        },
                      ]}
                    />

                  </Card>

                )}

                {dataType === "probability" && (

                  <Card title="Probability Distribution">

                    <Table
                      bordered
                      pagination={false}
                      rowKey={(r, i) => i}
                      dataSource={probabilityRows}
                      columns={[
                        {
                          title: "Value",

                          render: (_, record, index) => (

                            <InputNumber
                              style={{ width: "100%" }}
                              value={record.value}
                              onChange={(v) =>
                                updateProbabilityRow(
                                  index,
                                  "value",
                                  v
                                )
                              }
                            />

                          ),
                        },

                        {
                          title: "Probability",

                          render: (_, record, index) => (

                            <InputNumber
                              min={0}
                              max={1}
                              step={0.01}
                              style={{ width: "100%" }}
                              value={record.probability}
                              onChange={(v) =>
                                updateProbabilityRow(
                                  index,
                                  "probability",
                                  v
                                )
                              }
                            />

                          ),
                        },
                      ]}
                    />

                  </Card>

                )}

                <br />

                <Button
                  type="primary"
                  loading={loading}
                  onClick={handleCalculate}
                >
                  Calculate
                </Button>

              </>

            ),
          },
          {
            key: "2",
            label: "Results",

            children: (


              result ? (

                <>

                  <Card title="Summary Statistics">

                    <Table
                      bordered
                      pagination={false}
                      rowKey={(record) => record.key}
                      dataSource={Object.entries(
                        result.summary_data || {}
                      ).map(([key, value]) => ({
                        key,
                        Statistic: key.replace(/_/g, " "),
                        Value: Array.isArray(value)
                          ? value.join(", ")
                          : value,
                      }))}

                      columns={[
                        {
                          title: "Statistic",
                          dataIndex: "Statistic",
                        },

                        {
                          title: "Value",
                          dataIndex: "Value",
                        },
                      ]}
                    />

                  </Card>

                  <br />

                  <Card title="Calculation Table">

                    <Table
                      bordered
                      pagination={false}
                      rowKey={(record, index) => index}
                      dataSource={result.table_data || []}
                      columns={
                        result.table_data &&
                          result.table_data.length > 0
                          ? Object.keys(result.table_data[0]).map(
                            (key) => ({
                              title: key.replace(/_/g, " "),
                              dataIndex: key,
                            })
                          )
                          : []
                      }
                    />

                  </Card>

                </>

              ) : (

                <Card>
                  <Title level={5}>
                    No results available.
                  </Title>

                  <p>
                    Enter the input values and click
                    <b> Calculate </b>
                    to view the results.
                  </p>

                </Card>

              )

            ),
          },
        ]}
      />


    </Card>
  );
}

export default DataAnalysis;
